import { render, staticRenderFns } from "./brancheslist.html?vue&type=template&id=0344501d&scoped=true&"
import script from "./brancheslist.vue?vue&type=script&lang=js&"
export * from "./brancheslist.vue?vue&type=script&lang=js&"
import style0 from "./brancheslist.vue?vue&type=style&index=0&id=0344501d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344501d",
  null
  
)

export default component.exports